module.exports = __webpack_public_path__ + "static/media/violin.f0f30e78.wav";